const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    /* Alert the copied text */
    alert(`Copied to clipboard: ${text}`);
  });
};

export default copyToClipboard;
